import { createReducer, on } from '@ngrx/store';
import { PackageStatusState } from '@products/models/package-status.model';
import { ResetProductsActions } from '@store/products/product.actions';
import { PackageStatusActions } from '@store/products/status/package/package-status.actions';

export { PackageStatusState as State };

export const initialState: PackageStatusState = {
  lastPackageIndex: 0,
  isPackageLoading: false
};

export const packageStatusReducer = createReducer(
  initialState,
  on(PackageStatusActions.setInitialPackageIndexStatus, (state, { initialPackageIndex }) => ({
    ...state,
    lastPackageIndex: initialPackageIndex
  })),
  on(PackageStatusActions.setPackageIndexStatus, (state, { bookingPackageTypes }) => {
    if (bookingPackageTypes.length) {
      const lastPackageIndex = Math.max(
        ...bookingPackageTypes.map((bookingPackageType) => bookingPackageType.packageIndex),
        state.lastPackageIndex
      );

      return { ...state, lastPackageIndex };
    }

    return state;
  }),
  on(PackageStatusActions.setIsPackageLoadingStatus, (state, { isPackageLoading }) => ({ ...state, isPackageLoading })),
  on(PackageStatusActions.resetReducer, ResetProductsActions.resetStatusReducer, () => initialState)
);
